import '../../assets/css/common/table.css';
import '../../assets/css/common/common.css';
import { useTranslation } from 'react-i18next';
import { renderRowValue } from '../../utils/helpers/table';

const ViewTable = (props) => {
    const { heads, body, dataTable = [] } = props;
    const { t } = useTranslation();

    const renderHeads = () => {
        return (
            <tr>
                {heads
                    ?.filter((item) => !!item)
                    .map((head, index) => {
                        if (Object.keys(head).length === 0) {
                            return <></>;
                        }

                        return (
                            <th key={index} colSpan={head.colSpan} className={`v-select-default ${head.className}`}>
                                {head?.title}
                            </th>
                        );
                    })}
            </tr>
        );
    };

    const renderRows = () => {
        const headLength = heads?.filter((head) => head && !head.disabled).length;
        return (
            <>
                {dataTable.length > 0 ? (
                    <>
                        {dataTable?.map((itemRow, indexRow) => (
                            <tr key={indexRow} className={`v-select-default`}>
                                {body?.columns
                                    ?.filter((item) => !!item)
                                    .map((itemColumn, indexColumn) => {
                                        if (Object.keys(itemColumn).length === 0) {
                                            return <td key={indexColumn}></td>;
                                        }
                                        return (
                                            <td key={indexColumn} className={`${itemColumn?.className ?? ''}`}>
                                                <span className={itemColumn?.isLink ? 'components__table-link' : ''}>
                                                    {renderRowValue(t, itemColumn, itemRow)}
                                                </span>
                                            </td>
                                        );
                                    })}
                            </tr>
                        ))}
                    </>
                ) : (
                    <>
                        <div class="no-result-overlay">{'該当商品が見つかりません。'}</div>
                        <div className="hover-overlay"></div>
                        <tr className="no-result">
                            {headLength - 1 && <td colSpan={headLength - 1} className="no-result-left"></td>}
                            <td className="no-result-right freeze-right-0"></td>
                        </tr>
                    </>
                )}
            </>
        );
    };

    return (
        <div>
            <div className={`okc-table components__table-wrapper bases__padding--bottom20 `}>
                <div className="table-responsive">
                    <table className="w-100">
                        <thead>{renderHeads()}</thead>
                        <tbody className="okc-table__wrapper">{renderRows()}</tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ViewTable;
